import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader"
}

import { watch, onBeforeUnmount } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PageLoader',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props

    // Shared across all PageLoader instances so simultaneous loaders
    // (e.g. App.vue's router-ready loader and a view's data loader)
    // don't clobber each other's scroll lock. Uses the classic
    // position:fixed body-lock technique, which is more reliable than
    // overflow:hidden alone (works regardless of which element the
    // browser treats as the scrolling box).
    function applyLock() {
        const scrollY = window.scrollY;
        document.body.dataset.scrollLockY = String(scrollY);
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }

    function releaseLock() {
        const scrollY = parseInt(document.body.dataset.scrollLockY || '0', 10);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        delete document.body.dataset.scrollLockY;
        window.scrollTo(0, scrollY);
    }

    function setLocked(locked: boolean) {
        const w = window as any;
        const count = Math.max(0, (w.__pageLoaderLockCount ?? 0) + (locked ? 1 : -1));
        w.__pageLoaderLockCount = count;

        if (count > 0 && !w.__pageLoaderLocked) {
            w.__pageLoaderLocked = true;
            applyLock();
        } else if (count === 0 && w.__pageLoaderLocked) {
            w.__pageLoaderLocked = false;
            releaseLock();
        }
    }

    let isCurrentlyLocked = false
    watch(
        () => props.isLoading,
        (isLoading) => {
            if (isLoading === isCurrentlyLocked) return
            isCurrentlyLocked = isLoading
            setLocked(isLoading)
        },
        { immediate: true }
    )

    onBeforeUnmount(() => {
        if (isCurrentlyLocked) {
            isCurrentlyLocked = false
            setLocked(false)
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "spinner" }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})